import React from "react";
import { TRUST_POINTS } from "@/site.config";

export default function Credibility() {
  return (
    <section
      id="credibilite"
      data-testid="credibility-section"
      className="relative py-24 sm:py-28 px-5 sm:px-8 bg-[#0c0c0c] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-3 gap-12 items-start">
          <div className="lg:col-span-1">
            <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#9DEB30] mb-3">
              · Crédibilité
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight">
              Une intervention <span className="text-[#9DEB30]">sans compromis.</span>
            </h2>
            <p className="mt-4 text-zinc-400 max-w-md">
              Nos engagements concrets pour livrer un travail propre, sûr et conforme à vos attentes.
            </p>
          </div>

          <div className="lg:col-span-2 grid sm:grid-cols-2 gap-4">
            {TRUST_POINTS.map((p, i) => {
              const Icon = p.icon;
              return (
                <div
                  key={i}
                  data-testid={`trust-point-${i}`}
                  className="group flex items-start gap-4 p-6 rounded-2xl border border-white/10 bg-white/[0.02] hover:border-[#9DEB30]/40 hover:bg-[#9DEB30]/[0.03] transition-all"
                >
                  <div className="h-11 w-11 shrink-0 rounded-xl flex items-center justify-center bg-[#9DEB30]/10 border border-[#9DEB30]/30 text-[#9DEB30] group-hover:scale-110 transition-transform">
                    <Icon size={20} />
                  </div>
                  <div>
                    <div className="font-display text-lg font-bold leading-snug">
                      {p.label}
                    </div>
                    <div className="mt-1 text-xs font-mono text-zinc-500">
                      0{i + 1} · Garantie SIGNA CLEAN
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
